export default [
  {
    path: "/",
    redirect: "/login",
    hidden: true,
    meta: { menuShow: false },
  },
  {
    path: "/login",
    name: "Login",
    hidden: true,
    component: () => import("@/components/Login"),
    meta: { menuShow: false },
    children: [
      {
        path: "/login/createPassword",
        component: () => import("@/components/users/CreatePwd"),
        meta: { menuShow: false },
      },
    ],
  },
];
